export default {
    inserted(el) {
        const modal = el.querySelector('.ant-modal');
        const header = el.querySelector('.ant-modal-header');
        if (!header || !modal) return;

        header.style.cursor = 'move';
        let isDragging = false;
        let startX = 0;
        let startY = 0;

        const handleMove = (e) => {
            if (!isDragging) return;

            // 新增：检查鼠标左键是否仍被按住
            if (e.buttons !== 1) {
                stopDrag();
                return;
            }

            const currentScrollX = window.scrollX;
            const currentScrollY = window.scrollY;

            let newLeft = e.clientX + currentScrollX - startX;
            let newTop = e.clientY + currentScrollY - startY;

            const maxX = window.innerWidth - modal.offsetWidth;
            const maxY = window.innerHeight - modal.offsetHeight;
            newLeft = Math.max(0, Math.min(newLeft, maxX));
            newTop = Math.max(0, Math.min(newTop, maxY));

            modal.style.left = `${newLeft}px`;
            modal.style.top = `${newTop}px`;
        };

        const stopDrag = () => {
            isDragging = false;
            document.removeEventListener('mousemove', handleMove);
            document.removeEventListener('mouseup', stopDrag);
        };

        header.addEventListener('mousedown', (e) => {
            isDragging = true;
            const rect = modal.getBoundingClientRect();
            startX = e.clientX + window.scrollX - rect.left;
            startY = e.clientY + window.scrollY - rect.top;

            document.addEventListener('mousemove', handleMove);
            document.addEventListener('mouseup', stopDrag);
        });
    }
};